import { validStateCodesCA as e, validStateCodesUS as r } from "@cx-modules/constants";
import { isLoggedIn as u } from "./myoc.js";
const A = {
  AL: "Alabama",
  AK: "Alaska",
  AS: "American Samoa",
  AR: "Arkansas",
  AZ: "Arizona",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DC: "District of Columbia",
  DE: "Delaware",
  FL: "Florida",
  FM: "Federated States of Micronesia",
  GA: "Georgia",
  GU: "Guam",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NC: "North Carolina",
  ND: "North Dakota",
  NE: "Nebraska",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NV: "Nevada",
  NY: "New York",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  PR: "Puerto Rico",
  PW: "Palau",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  VI: "U.S. Virgin Islands",
  WA: "Washington",
  WI: "Wisconsin",
  WV: "West Virginia",
  WY: "Wyoming",
  MP: "Northern Mariana Islands",
  MH: "Marshall Islands"
}, N = {
  AB: "Alberta",
  BC: "British Columbia",
  MB: "Manitoba",
  NB: "New Brunswick",
  NL: "Newfoundland and Labrador",
  NS: "Nova Scotia",
  NT: "Northwest Territories",
  NU: "Nunavut",
  ON: "Ontario",
  PE: "Prince Edward Island",
  QC: "Quebec",
  SK: "Saskatchewan",
  YT: "Yukon"
}, n = (a, s) => a.reduce(
  (i, o) => (i[o] = { code: o, name: s[o] }, i),
  {}
), O = {
  US: {
    code: "US",
    name: "United States",
    subdivisions: n(r, A)
  },
  CA: {
    code: "CA",
    name: "Canada",
    subdivisions: n(e, N)
  }
};
var I = /* @__PURE__ */ ((a) => (a.desktop = "desktop", a.mobile = "mobile", a.tablet = "tablet", a))(I || {}), S = /* @__PURE__ */ ((a) => (a[a.mobile = 280] = "mobile", a[a.tablet = 450] = "tablet", a[a.desktop = 1024] = "desktop", a))(S || {});
const C = {
  LINK: "LINK",
  ALL_SPORTS_EXPANDABLE: "ALL_SPORTS_EXPANDABLE",
  FEATURED_LINKS: "FEATURED_LINKS",
  LINK_GROUP: "LINK_GROUP",
  GROUP: "GROUP",
  SPLIT_EXPANDABLE: "SPLIT_EXPANDABLE",
  FLAT_ITEMS_EXPANDABLE: "FLAT_ITEMS_EXPANDABLE",
  MY_ACCOUNT: "MY_ACCOUNT",
  ODDS_FORMAT: "ODDS_FORMAT",
  BETSLIP: "BETSLIP",
  STATE_SELECTOR: "STATE_SELECTOR"
}, T = {
  PROMO_CODE: "PROMO_CODE"
}, l = {
  primary: "primary",
  secondary: "secondary",
  tertiary: "tertiary"
}, L = {
  DISCLAIMER: "DISCLAIMER",
  LOGO: "LOGO"
}, t = {
  AMERICAN: "american",
  DECIMAL: "decimal",
  FRACTIONAL: "fractional",
  TRADITIONAL: "traditional"
}, d = (a) => ({
  American: a === t.AMERICAN,
  Decimal: a === t.DECIMAL,
  Fractional: a === t.FRACTIONAL
}), M = ["WS", "US", "OC", "GZ"], R = {
  GZ: "it",
  OC: "uk",
  US: "us",
  WS: "uk"
}, D = {
  OC: "uk",
  US: "us",
  WS: "uk",
  GZ: "it"
};
export {
  N as CA_SUBDIVISION_NAMES,
  I as Devices,
  S as MinScreenSizes,
  t as ODDS_FORMAT,
  R as REPUB_COUNTRY,
  D as REPUB_COUNTRY_BY_REPUB,
  M as SUPPORTED_REPUB_NAMES,
  A as US_SUBDIVISION_NAMES,
  O as countriesByCodeWithSubdivisions,
  L as footerItemType,
  d as getOddsFormatIs,
  u as isLoggedIn,
  C as navItemType,
  T as navItemsType,
  l as variant
};
